import LogsList from './LogsList';
export default LogsList;
